export const CHILEAN_REGIONS = [
  { value: "metropolitana", label: "Metropolitana" },
  { value: "tarapaca", label: "Tarapacá" },
  { value: "antofagasta", label: "Antofagasta" },
  { value: "atacama", label: "Atacama" },
  { value: "coquimbo", label: "Coquimbo" },
  { value: "valparaiso", label: "Valparaíso" },
  { value: "ohiggins", label: "O'Higgins" },
  { value: "maule", label: "Maule" },
  { value: "nuble", label: "Ñuble" },
  { value: "biobio", label: "Biobío" },
  { value: "araucania", label: "La Araucanía" },
  { value: "los_rios", label: "Los Ríos" },
  { value: "los_lagos", label: "Los Lagos" },
  { value: "aysen", label: "Aysén" },
  { value: "magallanes", label: "Magallanes" },
  { value: "arica_parinacota", label: "Arica y Parinacota" },
];

export const CHILEAN_COMUNAS = [
  // Arica y Parinacota
  { value: "arica", label: "Arica", region: "arica_parinacota" },
  { value: "camarones", label: "Camarones", region: "arica_parinacota" },
  { value: "putre", label: "Putre", region: "arica_parinacota" },
  {
    value: "general_lagos",
    label: "General Lagos",
    region: "arica_parinacota",
  },

  // Tarapacá
  { value: "iquique", label: "Iquique", region: "tarapaca" },
  { value: "alto_hospicio", label: "Alto Hospicio", region: "tarapaca" },
  { value: "pozo_almonte", label: "Pozo Almonte", region: "tarapaca" },
  { value: "camiña", label: "Camiña", region: "tarapaca" },
  { value: "colchane", label: "Colchane", region: "tarapaca" },
  { value: "huara", label: "Huara", region: "tarapaca" },
  { value: "pica", label: "Pica", region: "tarapaca" },

  // Antofagasta
  { value: "antofagasta", label: "Antofagasta", region: "antofagasta" },
  { value: "mejillones", label: "Mejillones", region: "antofagasta" },
  { value: "sierra_gorda", label: "Sierra Gorda", region: "antofagasta" },
  { value: "taltal", label: "Taltal", region: "antofagasta" },
  { value: "calama", label: "Calama", region: "antofagasta" },
  { value: "ollague", label: "Ollagüe", region: "antofagasta" },
  {
    value: "san_pedro_de_atacama",
    label: "San Pedro de Atacama",
    region: "antofagasta",
  },
  { value: "tocopilla", label: "Tocopilla", region: "antofagasta" },
  { value: "maria_elena", label: "María Elena", region: "antofagasta" },

  // Atacama
  { value: "copiapo", label: "Copiapó", region: "atacama" },
  { value: "caldera", label: "Caldera", region: "atacama" },
  { value: "tierra_amarilla", label: "Tierra Amarilla", region: "atacama" },
  { value: "chañaral", label: "Chañaral", region: "atacama" },
  { value: "diego_de_almagro", label: "Diego de Almagro", region: "atacama" },
  { value: "vallenar", label: "Vallenar", region: "atacama" },
  { value: "alto_del_carmen", label: "Alto del Carmen", region: "atacama" },
  { value: "freirina", label: "Freirina", region: "atacama" },
  { value: "huasco", label: "Huasco", region: "atacama" },

  // Coquimbo
  { value: "la_serena", label: "La Serena", region: "coquimbo" },
  { value: "coquimbo", label: "Coquimbo", region: "coquimbo" },
  { value: "andacollo", label: "Andacollo", region: "coquimbo" },
  { value: "la_higuera", label: "La Higuera", region: "coquimbo" },
  { value: "paiguano", label: "Paiguano", region: "coquimbo" },
  { value: "vicuña", label: "Vicuña", region: "coquimbo" },
  { value: "illapel", label: "Illapel", region: "coquimbo" },
  { value: "canela", label: "Canela", region: "coquimbo" },
  { value: "los_vilos", label: "Los Vilos", region: "coquimbo" },
  { value: "salamanca", label: "Salamanca", region: "coquimbo" },
  { value: "ovalle", label: "Ovalle", region: "coquimbo" },
  { value: "combarbala", label: "Combarbalá", region: "coquimbo" },
  { value: "monte_patria", label: "Monte Patria", region: "coquimbo" },
  { value: "punitaqui", label: "Punitaqui", region: "coquimbo" },
  { value: "rio_hurtado", label: "Río Hurtado", region: "coquimbo" },

  // Valparaíso
  { value: "valparaiso", label: "Valparaíso", region: "valparaiso" },
  { value: "casablanca", label: "Casablanca", region: "valparaiso" },
  { value: "concon", label: "Concón", region: "valparaiso" },
  { value: "juan_fernandez", label: "Juan Fernández", region: "valparaiso" },
  { value: "puchuncavi", label: "Puchuncaví", region: "valparaiso" },
  { value: "quintero", label: "Quintero", region: "valparaiso" },
  { value: "viña_del_mar", label: "Viña del Mar", region: "valparaiso" },
  { value: "isla_de_pascua", label: "Isla de Pascua", region: "valparaiso" },
  { value: "los_andes", label: "Los Andes", region: "valparaiso" },
  { value: "calle_larga", label: "Calle Larga", region: "valparaiso" },
  { value: "rinconada", label: "Rinconada", region: "valparaiso" },
  { value: "san_esteban", label: "San Esteban", region: "valparaiso" },
  { value: "la_ligua", label: "La Ligua", region: "valparaiso" },
  { value: "cabildo", label: "Cabildo", region: "valparaiso" },
  { value: "papudo", label: "Papudo", region: "valparaiso" },
  { value: "petorca", label: "Petorca", region: "valparaiso" },
  { value: "zapallar", label: "Zapallar", region: "valparaiso" },
  { value: "quillota", label: "Quillota", region: "valparaiso" },
  { value: "quilpue", label: "Quilpué", region: "valparaiso" },
  { value: "villa_alemana", label: "Villa Alemana", region: "valparaiso" },
  { value: "calera", label: "Calera", region: "valparaiso" },
  { value: "hijuelas", label: "Hijuelas", region: "valparaiso" },
  { value: "la_cruz", label: "La Cruz", region: "valparaiso" },
  { value: "limache", label: "Limache", region: "valparaiso" },
  { value: "nogales", label: "Nogales", region: "valparaiso" },
  { value: "olmue", label: "Olmué", region: "valparaiso" },
  { value: "san_antonio", label: "San Antonio", region: "valparaiso" },
  { value: "algarrobo", label: "Algarrobo", region: "valparaiso" },
  { value: "cartagena", label: "Cartagena", region: "valparaiso" },
  { value: "el_quisco", label: "El Quisco", region: "valparaiso" },
  { value: "el_tabo", label: "El Tabo", region: "valparaiso" },
  { value: "santo_domingo", label: "Santo Domingo", region: "valparaiso" },
  { value: "san_felipe", label: "San Felipe", region: "valparaiso" },
  { value: "catemu", label: "Catemu", region: "valparaiso" },
  { value: "llaillay", label: "Llaillay", region: "valparaiso" },
  { value: "panquehue", label: "Panquehue", region: "valparaiso" },
  { value: "putaendo", label: "Putaendo", region: "valparaiso" },
  { value: "santa_maria", label: "Santa María", region: "valparaiso" },

  // Metropolitana de Santiago
  { value: "santiago", label: "Santiago", region: "metropolitana" },
  { value: "cerrillos", label: "Cerrillos", region: "metropolitana" },
  { value: "cerro_navia", label: "Cerro Navia", region: "metropolitana" },
  { value: "conchali", label: "Conchalí", region: "metropolitana" },
  { value: "el_bosque", label: "El Bosque", region: "metropolitana" },
  {
    value: "estacion_central",
    label: "Estación Central",
    region: "metropolitana",
  },
  { value: "huechuraba", label: "Huechuraba", region: "metropolitana" },
  { value: "independencia", label: "Independencia", region: "metropolitana" },
  { value: "la_cisterna", label: "La Cisterna", region: "metropolitana" },
  { value: "la_florida", label: "La Florida", region: "metropolitana" },
  { value: "la_granja", label: "La Granja", region: "metropolitana" },
  { value: "la_pintana", label: "La Pintana", region: "metropolitana" },
  { value: "la_reina", label: "La Reina", region: "metropolitana" },
  { value: "las_condes", label: "Las Condes", region: "metropolitana" },
  { value: "lo_barnechea", label: "Lo Barnechea", region: "metropolitana" },
  { value: "lo_espejo", label: "Lo Espejo", region: "metropolitana" },
  { value: "lo_prado", label: "Lo Prado", region: "metropolitana" },
  { value: "macul", label: "Macul", region: "metropolitana" },
  { value: "maipu", label: "Maipú", region: "metropolitana" },
  { value: "ñuñoa", label: "Ñuñoa", region: "metropolitana" },
  {
    value: "pedro_aguirre_cerda",
    label: "Pedro Aguirre Cerda",
    region: "metropolitana",
  },
  { value: "peñalolen", label: "Peñalolén", region: "metropolitana" },
  { value: "providencia", label: "Providencia", region: "metropolitana" },
  { value: "pudahuel", label: "Pudahuel", region: "metropolitana" },
  { value: "quilicura", label: "Quilicura", region: "metropolitana" },
  { value: "quinta_normal", label: "Quinta Normal", region: "metropolitana" },
  { value: "recoleta", label: "Recoleta", region: "metropolitana" },
  { value: "renca", label: "Renca", region: "metropolitana" },
  { value: "san_joaquin", label: "San Joaquín", region: "metropolitana" },
  { value: "san_miguel", label: "San Miguel", region: "metropolitana" },
  { value: "san_ramon", label: "San Ramón", region: "metropolitana" },
  { value: "vitacura", label: "Vitacura", region: "metropolitana" },
  { value: "puente_alto", label: "Puente Alto", region: "metropolitana" },
  { value: "pirque", label: "Pirque", region: "metropolitana" },
  {
    value: "san_jose_de_maipo",
    label: "San José de Maipo",
    region: "metropolitana",
  },
  { value: "colina", label: "Colina", region: "metropolitana" },
  { value: "lampa", label: "Lampa", region: "metropolitana" },
  { value: "tiltil", label: "Tiltil", region: "metropolitana" },
  { value: "san_bernardo", label: "San Bernardo", region: "metropolitana" },
  { value: "buin", label: "Buin", region: "metropolitana" },
  {
    value: "calera_de_tango",
    label: "Calera de Tango",
    region: "metropolitana",
  },
  { value: "paine", label: "Paine", region: "metropolitana" },
  { value: "melipilla", label: "Melipilla", region: "metropolitana" },
  { value: "alhue", label: "Alhué", region: "metropolitana" },
  { value: "curacavi", label: "Curacaví", region: "metropolitana" },
  { value: "maria_pinto", label: "María Pinto", region: "metropolitana" },
  { value: "san_pedro", label: "San Pedro", region: "metropolitana" },
  { value: "talagante", label: "Talagante", region: "metropolitana" },
  { value: "el_monte", label: "El Monte", region: "metropolitana" },
  { value: "isla_de_maipo", label: "Isla de Maipo", region: "metropolitana" },
  { value: "padre_hurtado", label: "Padre Hurtado", region: "metropolitana" },
  { value: "peñaflor", label: "Peñaflor", region: "metropolitana" },

  // O'Higgins
  { value: "rancagua", label: "Rancagua", region: "ohiggins" },
  { value: "codegua", label: "Codegua", region: "ohiggins" },
  { value: "coinco", label: "Coinco", region: "ohiggins" },
  { value: "coltauco", label: "Coltauco", region: "ohiggins" },
  { value: "doñihue", label: "Doñihue", region: "ohiggins" },
  { value: "graneros", label: "Graneros", region: "ohiggins" },
  { value: "las_cabras", label: "Las Cabras", region: "ohiggins" },
  { value: "machali", label: "Machalí", region: "ohiggins" },
  { value: "malloa", label: "Malloa", region: "ohiggins" },
  { value: "mostazal", label: "Mostazal", region: "ohiggins" },
  { value: "olivar", label: "Olivar", region: "ohiggins" },
  { value: "peumo", label: "Peumo", region: "ohiggins" },
  { value: "pichidegua", label: "Pichidegua", region: "ohiggins" },
  {
    value: "quinta_de_tilcoco",
    label: "Quinta de Tilcoco",
    region: "ohiggins",
  },
  { value: "rengo", label: "Rengo", region: "ohiggins" },
  { value: "requinoa", label: "Requínoa", region: "ohiggins" },
  { value: "san_vicente", label: "San Vicente", region: "ohiggins" },
  { value: "pichilemu", label: "Pichilemu", region: "ohiggins" },
  { value: "la_estrella", label: "La Estrella", region: "ohiggins" },
  { value: "litueche", label: "Litueche", region: "ohiggins" },
  { value: "marchihue", label: "Marchihue", region: "ohiggins" },
  { value: "navidad", label: "Navidad", region: "ohiggins" },
  { value: "paredones", label: "Paredones", region: "ohiggins" },
  { value: "san_fernando", label: "San Fernando", region: "ohiggins" },
  { value: "chepica", label: "Chépica", region: "ohiggins" },
  { value: "chimbarongo", label: "Chimbarongo", region: "ohiggins" },
  { value: "lolol", label: "Lolol", region: "ohiggins" },
  { value: "nancagua", label: "Nancagua", region: "ohiggins" },
  { value: "palmilla", label: "Palmilla", region: "ohiggins" },
  { value: "peralillo", label: "Peralillo", region: "ohiggins" },
  { value: "placilla", label: "Placilla", region: "ohiggins" },
  { value: "pumanque", label: "Pumanque", region: "ohiggins" },
  { value: "santa_cruz", label: "Santa Cruz", region: "ohiggins" },

  // Maule
  { value: "talca", label: "Talca", region: "maule" },
  { value: "constitucion", label: "Constitución", region: "maule" },
  { value: "curepto", label: "Curepto", region: "maule" },
  { value: "empedrado", label: "Empedrado", region: "maule" },
  { value: "maule", label: "Maule", region: "maule" },
  { value: "pelarco", label: "Pelarco", region: "maule" },
  { value: "pencahue", label: "Pencahue", region: "maule" },
  { value: "rio_claro", label: "Río Claro", region: "maule" },
  { value: "san_clemente", label: "San Clemente", region: "maule" },
  { value: "san_rafael", label: "San Rafael", region: "maule" },
  { value: "cauquenes", label: "Cauquenes", region: "maule" },
  { value: "chanco", label: "Chanco", region: "maule" },
  { value: "pelluhue", label: "Pelluhue", region: "maule" },
  { value: "curico", label: "Curicó", region: "maule" },
  { value: "hualañe", label: "Hualañé", region: "maule" },
  { value: "licanten", label: "Licantén", region: "maule" },
  { value: "molina", label: "Molina", region: "maule" },
  { value: "rauco", label: "Rauco", region: "maule" },
  { value: "romeral", label: "Romeral", region: "maule" },
  { value: "sagrada_familia", label: "Sagrada Familia", region: "maule" },
  { value: "teno", label: "Teno", region: "maule" },
  { value: "vichuquen", label: "Vichuquén", region: "maule" },
  { value: "linares", label: "Linares", region: "maule" },
  { value: "colbun", label: "Colbún", region: "maule" },
  { value: "longavi", label: "Longaví", region: "maule" },
  { value: "parral", label: "Parral", region: "maule" },
  { value: "retiro", label: "Retiro", region: "maule" },
  { value: "san_javier", label: "San Javier", region: "maule" },
  { value: "villa_alegre", label: "Villa Alegre", region: "maule" },
  { value: "yerbas_buenas", label: "Yerbas Buenas", region: "maule" },

  // Ñuble
  { value: "chillan", label: "Chillán", region: "nuble" },
  { value: "bulnes", label: "Bulnes", region: "nuble" },
  { value: "cobquecura", label: "Cobquecura", region: "nuble" },
  { value: "coelemu", label: "Coelemu", region: "nuble" },
  { value: "coihueco", label: "Coihueco", region: "nuble" },
  { value: "chillan_viejo", label: "Chillán Viejo", region: "nuble" },
  { value: "el_carmen", label: "El Carmen", region: "nuble" },
  { value: "ninhue", label: "Ninhue", region: "nuble" },
  { value: "ñiquen", label: "Ñiquén", region: "nuble" },
  { value: "pemuco", label: "Pemuco", region: "nuble" },
  { value: "pinto", label: "Pinto", region: "nuble" },
  { value: "portezuelo", label: "Portezuelo", region: "nuble" },
  { value: "quillon", label: "Quillón", region: "nuble" },
  { value: "quirihue", label: "Quirihue", region: "nuble" },
  { value: "ranquil", label: "Ránquil", region: "nuble" },
  { value: "san_carlos", label: "San Carlos", region: "nuble" },
  { value: "san_fabian", label: "San Fabián", region: "nuble" },
  { value: "san_ignacio", label: "San Ignacio", region: "nuble" },
  { value: "san_nicolas", label: "San Nicolás", region: "nuble" },
  { value: "treguaco", label: "Treguaco", region: "nuble" },
  { value: "yungay", label: "Yungay", region: "nuble" },

  // Biobío
  { value: "concepcion", label: "Concepción", region: "biobio" },
  { value: "coronel", label: "Coronel", region: "biobio" },
  { value: "chiguayante", label: "Chiguayante", region: "biobio" },
  { value: "florida", label: "Florida", region: "biobio" },
  { value: "hualqui", label: "Hualqui", region: "biobio" },
  { value: "lota", label: "Lota", region: "biobio" },
  { value: "penco", label: "Penco", region: "biobio" },
  {
    value: "san_pedro_de_la_paz",
    label: "San Pedro de la Paz",
    region: "biobio",
  },
  { value: "santa_juana", label: "Santa Juana", region: "biobio" },
  { value: "talcahuano", label: "Talcahuano", region: "biobio" },
  { value: "tome", label: "Tomé", region: "biobio" },
  { value: "hualpen", label: "Hualpén", region: "biobio" },
  { value: "lebu", label: "Lebu", region: "biobio" },
  { value: "arauco", label: "Arauco", region: "biobio" },
  { value: "cañete", label: "Cañete", region: "biobio" },
  { value: "contulmo", label: "Contulmo", region: "biobio" },
  { value: "curanilahue", label: "Curanilahue", region: "biobio" },
  { value: "los_alamos", label: "Los Álamos", region: "biobio" },
  { value: "tirua", label: "Tirúa", region: "biobio" },
  { value: "los_angeles", label: "Los Ángeles", region: "biobio" },
  { value: "antuco", label: "Antuco", region: "biobio" },
  { value: "cabrero", label: "Cabrero", region: "biobio" },
  { value: "laja", label: "Laja", region: "biobio" },
  { value: "mulchen", label: "Mulchén", region: "biobio" },
  { value: "nacimiento", label: "Nacimiento", region: "biobio" },
  { value: "negrete", label: "Negrete", region: "biobio" },
  { value: "quilaco", label: "Quilaco", region: "biobio" },
  { value: "quilleco", label: "Quilleco", region: "biobio" },
  { value: "san_rosendo", label: "San Rosendo", region: "biobio" },
  { value: "santa_barbara", label: "Santa Bárbara", region: "biobio" },
  { value: "tucapel", label: "Tucapel", region: "biobio" },
  { value: "yumbel", label: "Yumbel", region: "biobio" },
  { value: "alto_biobio", label: "Alto Biobío", region: "biobio" },

  // La Araucanía
  { value: "temuco", label: "Temuco", region: "araucania" },
  { value: "carahue", label: "Carahue", region: "araucania" },
  { value: "cunco", label: "Cunco", region: "araucania" },
  { value: "curarrehue", label: "Curarrehue", region: "araucania" },
  { value: "freire", label: "Freire", region: "araucania" },
  { value: "galvarino", label: "Galvarino", region: "araucania" },
  { value: "gorbea", label: "Gorbea", region: "araucania" },
  { value: "lautaro", label: "Lautaro", region: "araucania" },
  { value: "loncoche", label: "Loncoche", region: "araucania" },
  { value: "melipeuco", label: "Melipeuco", region: "araucania" },
  { value: "nueva_imperial", label: "Nueva Imperial", region: "araucania" },
  { value: "padre_las_casas", label: "Padre las Casas", region: "araucania" },
  { value: "perquenco", label: "Perquenco", region: "araucania" },
  { value: "pitrufquen", label: "Pitrufquén", region: "araucania" },
  { value: "pucon", label: "Pucón", region: "araucania" },
  { value: "saavedra", label: "Saavedra", region: "araucania" },
  { value: "teodoro_schmidt", label: "Teodoro Schmidt", region: "araucania" },
  { value: "tolten", label: "Toltén", region: "araucania" },
  { value: "vilcun", label: "Vilcún", region: "araucania" },
  { value: "villarrica", label: "Villarrica", region: "araucania" },
  { value: "cholchol", label: "Cholchol", region: "araucania" },
  { value: "angol", label: "Angol", region: "araucania" },
  { value: "collipulli", label: "Collipulli", region: "araucania" },
  { value: "curacautin", label: "Curacautín", region: "araucania" },
  { value: "ercilla", label: "Ercilla", region: "araucania" },
  { value: "lonquimay", label: "Lonquimay", region: "araucania" },
  { value: "los_sauces", label: "Los Sauces", region: "araucania" },
  { value: "lumaco", label: "Lumaco", region: "araucania" },
  { value: "puren", label: "Purén", region: "araucania" },
  { value: "renaico", label: "Renaico", region: "araucania" },
  { value: "traiguen", label: "Traiguén", region: "araucania" },
  { value: "victoria", label: "Victoria", region: "araucania" },

  // Los Ríos
  { value: "valdivia", label: "Valdivia", region: "los_rios" },
  { value: "corral", label: "Corral", region: "los_rios" },
  { value: "lanco", label: "Lanco", region: "los_rios" },
  { value: "los_lagos", label: "Los Lagos", region: "los_rios" },
  { value: "mafil", label: "Máfil", region: "los_rios" },
  { value: "mariquina", label: "Mariquina", region: "los_rios" },
  { value: "paillaco", label: "Paillaco", region: "los_rios" },
  { value: "panguipulli", label: "Panguipulli", region: "los_rios" },
  { value: "la_union", label: "La Unión", region: "los_rios" },
  { value: "futrono", label: "Futrono", region: "los_rios" },
  { value: "lago_ranco", label: "Lago Ranco", region: "los_rios" },
  { value: "rio_bueno", label: "Río Bueno", region: "los_rios" },

  // Los Lagos
  { value: "puerto_montt", label: "Puerto Montt", region: "los_lagos" },
  { value: "calbuco", label: "Calbuco", region: "los_lagos" },
  { value: "cochamo", label: "Cochamó", region: "los_lagos" },
  { value: "fresia", label: "Fresia", region: "los_lagos" },
  { value: "frutillar", label: "Frutillar", region: "los_lagos" },
  { value: "los_muermos", label: "Los Muermos", region: "los_lagos" },
  { value: "llanquihue", label: "Llanquihue", region: "los_lagos" },
  { value: "maullin", label: "Maullín", region: "los_lagos" },
  { value: "puerto_varas", label: "Puerto Varas", region: "los_lagos" },
  { value: "castro", label: "Castro", region: "los_lagos" },
  { value: "ancud", label: "Ancud", region: "los_lagos" },
  { value: "chonchi", label: "Chonchi", region: "los_lagos" },
  { value: "curaco_de_velez", label: "Curaco de Vélez", region: "los_lagos" },
  { value: "dalcahue", label: "Dalcahue", region: "los_lagos" },
  { value: "puqueldon", label: "Puqueldón", region: "los_lagos" },
  { value: "queilen", label: "Queilén", region: "los_lagos" },
  { value: "quellon", label: "Quellón", region: "los_lagos" },
  { value: "quinchao", label: "Quinchao", region: "los_lagos" },
  { value: "osorno", label: "Osorno", region: "los_lagos" },
  { value: "puerto_octay", label: "Puerto Octay", region: "los_lagos" },
  { value: "purranque", label: "Purranque", region: "los_lagos" },
  { value: "puyehue", label: "Puyehue", region: "los_lagos" },
  { value: "rio_negro", label: "Río Negro", region: "los_lagos" },
  {
    value: "san_juan_de_la_costa",
    label: "San Juan de la Costa",
    region: "los_lagos",
  },
  { value: "san_pablo", label: "San Pablo", region: "los_lagos" },
  { value: "chaiten", label: "Chaitén", region: "los_lagos" },
  { value: "futaleufu", label: "Futaleufú", region: "los_lagos" },
  { value: "hualaihue", label: "Hualaihué", region: "los_lagos" },
  { value: "palena", label: "Palena", region: "los_lagos" },

  // Aysén
  { value: "coyhaique", label: "Coyhaique", region: "aysen" },
  { value: "lago_verde", label: "Lago Verde", region: "aysen" },
  { value: "aysen", label: "Aysén", region: "aysen" },
  { value: "cisnes", label: "Cisnes", region: "aysen" },
  { value: "guaitecas", label: "Guaitecas", region: "aysen" },
  { value: "cochrane", label: "Cochrane", region: "aysen" },
  { value: "ohiggins", label: "O'Higgins", region: "aysen" },
  { value: "tortel", label: "Tortel", region: "aysen" },
  { value: "chile_chico", label: "Chile Chico", region: "aysen" },
  { value: "rio_ibañez", label: "Río Ibáñez", region: "aysen" },

  // Magallanes
  { value: "punta_arenas", label: "Punta Arenas", region: "magallanes" },
  { value: "laguna_blanca", label: "Laguna Blanca", region: "magallanes" },
  { value: "rio_verde", label: "Río Verde", region: "magallanes" },
  { value: "san_gregorio", label: "San Gregorio", region: "magallanes" },
  { value: "cabo_de_hornos", label: "Cabo de Hornos", region: "magallanes" },
  { value: "antartica", label: "Antártica", region: "magallanes" },
  { value: "porvenir", label: "Porvenir", region: "magallanes" },
  { value: "primavera", label: "Primavera", region: "magallanes" },
  { value: "timaukel", label: "Timaukel", region: "magallanes" },
  { value: "puerto_natales", label: "Puerto Natales", region: "magallanes" },
  {
    value: "torres_del_paine",
    label: "Torres del Paine",
    region: "magallanes",
  },
];
